import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=03435250&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=03435250&prod&scoped=true&lang=css&external"
import style1 from "./Permissions.vue?vue&type=style&index=1&id=03435250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03435250",
  null
  
)

export default component.exports